var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"regimen":_vm.regimen}})
}
var staticRenderFns = []

export { render, staticRenderFns }